// extracted by mini-css-extract-plugin
export default {"courseBanner":"TopLeftElement_courseBanner__46J1k","coursebannerspadding":"TopLeftElement_coursebannerspadding__77sKK","courseBannerImage":"TopLeftElement_courseBannerImage__pfZww"};